/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { AbstractCommand } from '../AbstractCommand';
import { ModelUtils } from '../util/ModelUtils';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';

/**
 * A command used to modify the description of a document.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class ChangeDescriptionCommand extends AbstractCommand {
    public _newDescription : string;

    public _oldDescription : string;

    public _nullInfo : boolean;

    public constructor(newDescription? : any) {
        if(((typeof newDescription === 'string') || newDescription === null)) {
            let __args = arguments;
            super();
            if(this._newDescription===undefined) this._newDescription = null;
            if(this._oldDescription===undefined) this._oldDescription = null;
            if(this._nullInfo===undefined) this._nullInfo = false;
            if(this._newDescription===undefined) this._newDescription = null;
            if(this._oldDescription===undefined) this._oldDescription = null;
            if(this._nullInfo===undefined) this._nullInfo = false;
            (() => {
                this._newDescription = newDescription;
            })();
        } else if(newDescription === undefined) {
            let __args = arguments;
            super();
            if(this._newDescription===undefined) this._newDescription = null;
            if(this._oldDescription===undefined) this._oldDescription = null;
            if(this._nullInfo===undefined) this._nullInfo = false;
            if(this._newDescription===undefined) this._newDescription = null;
            if(this._oldDescription===undefined) this._oldDescription = null;
            if(this._nullInfo===undefined) this._nullInfo = false;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[ChangeDescriptionCommand] Executing.");
        if(ModelUtils.isNullOrUndefined(document.info)) {
            document.info = document.createInfo();
            this._nullInfo = true;
            this._oldDescription = null;
        } else {
            this._oldDescription = document.info.description;
        }
        document.info.description = this._newDescription;
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[ChangeDescriptionCommand] Reverting.");
        if(this._nullInfo) {
            document.info = null;
        } else {
            document.info.description = this._oldDescription;
        }
    }
}
ChangeDescriptionCommand["__class"] = "io.apicurio.datamodels.cmd.commands.ChangeDescriptionCommand";
ChangeDescriptionCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




